import Joi from 'joi';

/**
 * Schema for renter user settings updates.
 */
export const updateProtoUserSettingsSchema = () =>
  Joi.object({
    languageId: Joi.number().integer().allow(null).messages({
      'number.base': 'validations|user-settings-language-id|must-be-number',
    }),
    timezone: Joi.string().allow(null).messages({
      'string.base': 'validations|user-settings-timezone|must-be-string',
    }),
  }).unknown();
